import { useRef, useState } from 'react';
import usePhoenixForm from './usePheonixForm';

const submitEvent = new Event('submit', {
  bubbles: true,
  cancelable: true
});

const useWizardForm = ({
  validation,
  totalStep: initialTotalStep,
  defaultValues
}) => {
  const [selectedStep, setSelectedStep] = useState(0);
  const [openDeniedModal, setOpenDeniedModal] = useState(false);
  const [totalStep, setTotalStep] = useState(initialTotalStep);
  const formRefs = useRef([]);
  const methods = usePhoenixForm(defaultValues);

  const goToStep = targetStep => {
    // if (selectedStep === totalStep && targetStep < selectedStep) {
    //   setOpenDeniedModal(true);
    //   return;
    // }
    if (targetStep <= totalStep && targetStep >= 0) {
      if (selectedStep > targetStep) {
        setSelectedStep(Number(targetStep));
      } else {
        const form = formRefs.current[selectedStep - 1];

        if (form) {
          form.dispatchEvent(submitEvent);
          if (form.checkValidity() || !validation) {
            setSelectedStep(Number(targetStep));
          } else {
            form.classList.add('was-validated');
          }
        }
      }
    }
  };

  const startOver = () => {
    setSelectedStep(0);
    methods.setFormData({});
  };

  const getCanNextPage = selectedStep < totalStep;

  const getCanPreviousPage = selectedStep >= 1;

  return {
    selectedStep,
    setSelectedStep,
    ...methods,
    formRefs,
    startOver,
    goToStep,
    validation: !!validation,
    totalStep,
    setTotalStep,
    getCanNextPage,
    getCanPreviousPage,
    openDeniedModal,
    setOpenDeniedModal
  };
};

export default useWizardForm;
